// Shape mínima que necesitamos de una compañía para sacar su inicial.
// Usamos businessName porque es el campo principal de Company en la app.
// Dejamos name como fallback por si otro módulo manda una estructura más genérica.
type CompanyLike = {
  businessName?: string | null;
  name?: string | null;
};

// Devuelve la primera letra visible del nombre de la compañía.
// Si no hay nombre válido, devuelve "?" para que el Avatar siempre tenga contenido.
export const getCompanyInitial = (company?: CompanyLike | null): string => {
  // Intenta usar businessName primero. Si no existe, intenta name. Si tampoco existe, usa string vacío.
  const label = company?.businessName || company?.name || "";

  // Limpia espacios, toma la primera letra, la pone en mayúscula y usa "?" como fallback.
  return label.trim().charAt(0).toUpperCase() || "?";
};
